import { render } from "./AddPost.vue?vue&type=template&id=b1ea6bf6&scoped=true"
import script from "./AddPost.vue?vue&type=script&lang=js"
export * from "./AddPost.vue?vue&type=script&lang=js"

import "./AddPost.vue?vue&type=style&index=0&id=b1ea6bf6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1ea6bf6"]])

export default __exports__